export default __webpack_public_path__ + "static/media/box_pc.5be039eb.png";